import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudGenericsService } from '../common/crud-generics';
import { Environment, FasiControlloProcedure, FasiControlloProcedureModel, FasiInProceduraModel } from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class FasiControlloProcedureService extends CrudGenericsService<FasiControlloProcedure, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/FasiControlloProcedure`);
    this.base = `${env.apiUrl}/api/FasiControlloProcedure/`;
  }
  // web
  GetAll_FasiContProcModel(): Observable<FasiControlloProcedureModel[]> {
    const url = this.base + 'GetAll_FasiContProcModel';
    return this.http.get<FasiControlloProcedureModel[]>(`${url}`);
  }
  // web
  GetFasiInProc_ByIdProc(id: number): Observable<FasiInProceduraModel[]> {
    const url = this.base + 'GetFasiInProc_ByIdProc?id=' + id;
    return this.http.get<FasiInProceduraModel[]>(`${url}`);
  }
  Drag_Sequenza(item: FasiControlloProcedure, next: number) {
    const url = this.base + 'Drag_Sequenza?next=' + next;
    return this.http.post(`${url}`, item);
  }
}
